import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]
  static outlets = ["toggle"] // other toggle controllers
  static values = { display: String }

  connect() {
    if (this.hasDisplayValue) {
      this.initialDisplay = this.displayValue
    } else {
      this.initialDisplay = this.element.style.display
    }
    if (this.initialDisplay === 'none') {
      this.initialDisplay = ''
    }
  }

  get togglable() {
    if (this.hasToggleTarget) {
      return this.toggleTarget
    } else {
      return this.element
    }
  }

  show() {
    this.togglable.style.display = this.initialDisplay
  }

  hide() {
    this.togglable.style.display = 'none'
  }

  toggle(e) {
    if (this.togglable.style.display === 'none') {
      this.show()
    } else {
      this.hide()
    }
  }

  showOtherControllers() {
    if (!this.hasToggleOutlet) { return }

    for (const outlet of this.toggleOutlets) {
      outlet.show()
    }
  }

  hideOtherControllers() {
    if (!this.hasToggleOutlet) { return }

    for (const outlet of this.toggleOutlets) {
      outlet.hide()
    }
  }

  toggleOtherControllers() {
    if (!this.hasToggleOutlet) { return }

    for (const outlet of this.toggleOutlets) {
      outlet.toggle()
    }
  }
}
